/* Rediseño 2026-10 · zona colección — barra "Filtrar y ordenar", barra fija compacta,
   atajos con conteo, agotados ocultos por defecto. Filtros nativos de Shopify: este
   archivo sólo arma URLs (filter.*, sort_by, /collections/x/<tag>) y lee conteos de la
   vista ?view=mld-coleccion-data. No toca carrito, MoldaClub ni quick view. */
(function () {
  'use strict';
  var H = document.documentElement;
  var TAG_LABELS = { peonias: 'Peonías', angeles: 'Ángeles', arcoiris: 'Arcoíris', numeros: 'Números', 'porta-inciensos': 'Porta inciensos' };
  var DATA_VIEW = 'mld-coleccion-data';
  var PLUS = '<svg class="mld-col-sug__plus" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" aria-hidden="true"><path d="M8 3.5v9M3.5 8h9"/></svg>';
  var ICO_SEARCH = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" aria-hidden="true"><circle cx="7" cy="7" r="4.75"/><path d="M10.5 10.5L14 14"/></svg>';

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(x) { return String(x == null ? '' : x).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function setCookie(name, value, days) {
    var d = new Date(); d.setTime(d.getTime() + days * 864e5);
    document.cookie = name + '=' + value + '; expires=' + d.toUTCString() + '; path=/';
  }
  function fmt(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function tagLabel(t) { return TAG_LABELS[t[0]] || (t[1].charAt(0).toUpperCase() + t[1].slice(1)); }
  /* Etiqueta de la vista de datos ([handle, nombre, conStock, total]) que coincide con alguna
     palabra (singular/plural); solo etiquetas con productos. */
  function matchTag(tags, words) {
    var ws = wordSet(words), hit = null;
    (tags || []).some(function (t) { if (t[0] !== 'x3' && t[3] > 0 && stems(t[0]).some(function (x) { return ws[x]; })) { hit = t; return true; } });
    return hit;
  }

  function init() {
    var bar = $('[data-mld-bar]');
    if (!bar || bar.__mld) return;
    bar.__mld = true;

    var mode = bar.getAttribute('data-mode');
    var base = bar.getAttribute('data-base') || location.pathname;
    var baseQuery = bar.getAttribute('data-base-query') || '';
    var curTag = bar.getAttribute('data-tag') || '';
    var defSort = bar.getAttribute('data-default-sort') || '';
    var tools = $('[data-mld-tools]', bar);
    var sheet = $('[data-mld-sheet]');
    var scrim = $('[data-mld-scrim]');
    var cur = new URLSearchParams(location.search);
    var urlAvail = cur.get('filter.v.availability');
    var hideOOS = H.classList.contains('mld-hide-oos');
    var useAvail = hideOOS || urlAvail === '1';     /* conteos "con stock" */

    if (sheet) document.body.appendChild(sheet);
    if (scrim) document.body.appendChild(scrim);

    /* ── URLs ─────────────────────────────────────────────── */
    function pathFor(tag) { return base + (tag ? '/' + tag : ''); }
    function cleanParams(p) { p.delete('page'); if (p.get('view') === DATA_VIEW) p.delete('view'); return p; }
    /* URL actual con un cambio (para atajos): agrega disponibilidad si estamos ocultando agotados. */
    function hrefWith(tag, mutate) {
      var p = cleanParams(new URLSearchParams(location.search));
      if (mode === 'search') { if (!p.get('type')) p.set('type', 'product'); }
      if (mode === 'catalog') { p.set('view', 'lista'); }
      if (hideOOS && !p.get('filter.v.availability')) p.set('filter.v.availability', '1');
      if (mutate) mutate(p);
      var qs = p.toString();
      return pathFor(tag) + (qs ? '?' + qs : '');
    }
    function dataUrl(path, params, page) {
      var p = new URLSearchParams(params);
      p.delete('page'); p.delete('mld_sort');
      p.set('view', DATA_VIEW);
      if (mode === 'search' && !p.get('type')) p.set('type', 'product');
      if (page > 1) p.set('page', page);
      return path + '?' + p.toString();
    }

    /* ── Estado de la hoja → URL destino ─────────────────── */
    function sheetState() {
      var st = { sort: '', tag: '', oos: false, gte: '', lte: '', list: [] };
      if (!sheet) return st;
      var s = $('input[name="mld_sort"]:checked', sheet); st.sort = s ? s.value : '';
      var t = $('input[name="mld_tag"]:checked', sheet); st.tag = t ? t.value : '';
      var o = $('[data-mld-oos]', sheet); st.oos = !!(o && o.checked);
      var g = $('[data-mld-gte]', sheet), l = $('[data-mld-lte]', sheet);
      st.gte = g ? g.value.trim() : ''; st.lte = l ? l.value.trim() : '';
      st.gteName = g ? g.name : 'filter.v.price.gte'; st.lteName = l ? l.name : 'filter.v.price.lte';
      $$('input[type="checkbox"][name^="filter."]', sheet).forEach(function (c) { if (c.checked) st.list.push([c.name, c.value]); });
      return st;
    }
    function targetParams(st) {
      var p = new URLSearchParams(baseQuery);
      if (!st.oos) p.set('filter.v.availability', '1');
      st.list.forEach(function (kv) { p.append(kv[0], kv[1]); });
      if (st.gte !== '') p.set(st.gteName, st.gte);
      if (st.lte !== '') p.set(st.lteName, st.lte);
      if (st.sort === 'discount') p.set('mld_sort', 'discount');
      else if (st.sort && st.sort !== defSort) p.set('sort_by', st.sort);
      return p;
    }
    function targetPath(st) {
      var path = pathFor(st.tag);
      if (mode === 'catalog') { /* el mosaico no lista productos: los filtros abren la grilla completa */ }
      return path;
    }
    function targetUrl(st) {
      var p = targetParams(st);
      if (mode === 'catalog') p.set('view', 'lista');
      var qs = p.toString();
      return targetPath(st) + (qs ? '?' + qs : '');
    }

    /* ── Atajos con conteo (datos reales de la vista de datos) ── */
    function priceActive(lo, hi) {
      var g = cur.get('filter.v.price.gte') || '', l = cur.get('filter.v.price.lte') || '';
      return String(g) === String(lo) && String(l) === String(hi);
    }
    function renderAtajos(data) {
      var html = '';
      var k = useAvail ? 0 : 1;   /* índice: [con stock, total] */
      if (data && data.tags && data.tags.length) {
        var tags = data.tags.filter(function (t) { return t[0] !== 'x3' && (t[2 + k] > 1 || t[0] === curTag); })
          .sort(function (a, b) { return b[2 + k] - a[2 + k]; }).slice(0, 4);
        if (curTag && !tags.some(function (t) { return t[0] === curTag; })) {
          var ct = data.tags.filter(function (t) { return t[0] === curTag; })[0]; if (ct) tags.unshift(ct);
        }
        tags.forEach(function (t) {
          if (t[0] === curTag) return;   /* la temática activa ya está como chip quitable */
          html += '<a class="mld-col-btn mld-col-sug" href="' + esc(hrefWith(t[0])) + '">' + PLUS +
            esc(TAG_LABELS[t[0]] || (t[1].charAt(0).toUpperCase() + t[1].slice(1))) + ' <span class="mld-col-n">' + t[2 + k] + '<span class="mld-col-sr"> productos</span></span></a>';
        });
      }
      if (data && data.price) {
        var n1 = data.price[0][k];
        var anyPrice = cur.get('filter.v.price.gte') || cur.get('filter.v.price.lte');
        if (n1 > 0 && !anyPrice) {   /* con un precio aplicado, el chip quitable lo reemplaza */
          html += '<a class="mld-col-btn mld-col-sug" href="' + esc(hrefWith(curTag, function (p) {
            p.delete('filter.v.price.gte'); p.set('filter.v.price.lte', '300');
          })) + '">' + PLUS + 'Hasta $300 <span class="mld-col-n">' + n1 + '<span class="mld-col-sr"> productos</span></span></a>';
        }
      }
      $$('[data-mld-atajos]', bar).forEach(function (el) { el.innerHTML = html; });
      /* conteos en la hoja */
      if (sheet && data) {
        if (data.price) $$('[data-mld-pn]', sheet).forEach(function (el) { var i = +el.getAttribute('data-mld-pn'); el.textContent = data.price[i] ? data.price[i][k] : ''; });
        if (data.tags) {
          var byH = {}; data.tags.forEach(function (t) { byH[t[0]] = t; });
          $$('[data-mld-tag]', sheet).forEach(function (el) {
            var t = byH[el.getAttribute('data-mld-tag')];
            var n = t ? t[2 + k] : 0;
            var lab = $('[data-mld-tag-label]', el); if (lab && TAG_LABELS[el.getAttribute('data-mld-tag')]) lab.textContent = TAG_LABELS[el.getAttribute('data-mld-tag')];
            $('[data-mld-tn]', el).textContent = n;
            el.classList.toggle('is-empty', n === 0 && el.getAttribute('data-mld-tag') !== curTag);
          });
        }
      }
    }

    function fetchJSON(u) {
      return fetch(u, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (t) { return JSON.parse(t.slice(t.indexOf('{'))); });
    }
    function loadData(path, params) {
      return fetchJSON(dataUrl(path, params, 1)).then(function (d) {
        if (!d.pages || d.pages <= 1) return d;
        var more = [];
        for (var i = 2; i <= Math.min(d.pages, 3); i++) more.push(fetchJSON(dataUrl(path, params, i)));
        return Promise.all(more).then(function (rs) {
          rs.forEach(function (x) {
            d.na += x.na;
            for (var i = 0; i < 3; i++) { d.price[i][0] += x.price[i][0]; d.price[i][1] += x.price[i][1]; }
            (x.tags || []).forEach(function (t, j) { if (d.tags[j] && d.tags[j][0] === t[0]) { d.tags[j][2] += t[2]; d.tags[j][3] += t[3]; } });
          });
          return d;
        });
      });
    }
    /* Contexto de los conteos: la ruta base (sin etiqueta) con los filtros actuales. */
    var ctxParams = cleanParams(new URLSearchParams(location.search));
    if (mode === 'catalog') ctxParams = new URLSearchParams();
    ctxParams.delete('view');
    /* Con una temática activa, los conteos de precio salen de esa temática (los de temáticas, de la base). */
    var atajosP = loadData(base, ctxParams).then(function (d) {
      if (!curTag) return d;
      return fetchJSON(dataUrl(pathFor(curTag), ctxParams, 1)).then(function (t) { d.price = t.price; return d; }).catch(function () { return d; });
    });

    /* Búsqueda: atajo "Ver categoría X" con su conteo real */
    $$('[data-mld-go]').forEach(function (a) {
      var u = a.getAttribute('data-mld-go');
      if (hideOOS || urlAvail === '1') a.href = u + (u.indexOf('?') > -1 ? '&' : '?') + 'filter.v.availability=1';
    });
    var go = $('[data-mld-go]');
    var goP = Promise.resolve();
    if (go) {
      var gp = new URLSearchParams(); if (useAvail) gp.set('filter.v.availability', '1');
      var gpath = go.getAttribute('data-mld-go').split('?')[0];
      var gwords = go.getAttribute('data-mld-go-words') || '';
      goP = fetchJSON(dataUrl(gpath, gp, 1)).then(function (d) {
        /* Material + forma: si otra palabra del término es una etiqueta real del material
           ("vela flor" → velas/flores), el atajo va ahí, con el conteo de esa etiqueta. */
        var t = gwords && matchTag(d.tags, gwords);
        if (t) return { n: t[2 + (useAvail ? 0 : 1)], href: gpath + '/' + t[0], label: tagLabel(t) };
        return { n: d.n };
      }).catch(function () { return null; });
    }
    /* Conteo de la categoría y sugerencias se pintan juntos: nada se corre de lado dos veces. */
    Promise.all([goP, atajosP.catch(function () { return null; })]).then(function (r) {
      var g = r[0];
      if (g && g.href) {
        $$('[data-mld-go]').forEach(function (a) {
          a.href = g.href + (useAvail ? '?filter.v.availability=1' : '');
          var l = $('[data-mld-go-l]', a); if (l) l.textContent = l.textContent + ': ' + g.label;
        });
      }
      if (g && g.n != null) $$('[data-mld-go-n]').forEach(function (el) { el.textContent = fmt(g.n); });
      if (r[1]) renderAtajos(r[1]);
    });

    /* ── Chips de filtros aplicados ───────────────────────── */
    $$('[data-mld-chip-tag]', bar).forEach(function (a) { a.href = hrefWith(''); });
    /* "Incluye sin stock" ya viene en Liquid (visible con html.mld-show-oos, antes del primer pintado). */
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-mld-chip-oos],[data-mld-clearall]');
      if (!a) return;
      setCookie('showOutOfStock', 'false', 7);
      if (a.hasAttribute('data-mld-chip-oos')) { e.preventDefault(); location.reload(); }
    });

    /* ── Barra fija compacta ─────────────────────────────── */
    var fixed = null;
    var core = $('[data-mld-tools-core]', bar);
    if (core && tools) {
      fixed = document.createElement('div');
      fixed.className = 'mld-col-fixed';
      fixed.setAttribute('data-mld-fixed', '');
      fixed.setAttribute('aria-hidden', 'true');
      var inner = document.createElement('div'); inner.className = 'mld-col-fixed__in';
      var catLabel = bar.getAttribute('data-cat-label');
      if (catLabel) {
        var cb = document.createElement('button');
        cb.type = 'button'; cb.className = 'mld-col-btn mld-col-btn--cat'; cb.setAttribute('data-mld-top', '');
        cb.innerHTML = (mode === 'search' ? ICO_SEARCH + ' ' : '') + esc(catLabel) +
          (mode === 'search' ? '' : ' <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 6l4 4 4-4"/></svg>');
        /* El nombre accesible empieza con el texto visible (WCAG 2.5.3) */
        cb.setAttribute('aria-label', catLabel + (mode === 'search' ? ', volver a la búsqueda' : ', ver categorías'));
        inner.appendChild(cb);
      }
      /* Barra fija: categoría + "Filtrar y ordenar" + resumen de lo APLICADO (o el conteo).
         Las sugerencias no viajan: arriba nada se lee como filtro activo si no lo es. */
      var mainBtn = $('[data-mld-open]', core);
      if (mainBtn) { var mb2 = mainBtn.cloneNode(true); mb2.removeAttribute('id'); inner.appendChild(mb2); }
      var applied = $('[data-mld-applied]', bar);
      var labels = applied ? $$('[data-mld-chip]', applied).filter(function (c) { return getComputedStyle(c).display !== 'none'; })
        .map(function (c) { return c.textContent.trim(); }) : [];
      if (labels.length) {
        /* Tocar el resumen abre la hoja (ver/editar); solo la × separada quita todo (prevención de errores). */
        var nTxt = labels.length + (labels.length === 1 ? ' filtro' : ' filtros');
        var sum = document.createElement('button');
        sum.type = 'button';
        sum.className = 'mld-col-chip mld-col-sum';
        sum.setAttribute('data-mld-open', '');
        sum.setAttribute('aria-expanded', 'false');
        sum.setAttribute('aria-label', nTxt + ': ' + labels.join(' · ') + '. Ver y editar filtros');
        sum.innerHTML = '<span class="mld-col-sum__t"><b>' + esc(nTxt) + '</b> · ' + esc(labels.join(' · ')) + '</span>';
        inner.appendChild(sum);
        var clr = document.createElement('a');
        clr.className = 'mld-col-sum-x';
        clr.href = ($('[data-mld-clearall]', applied) || {}).href || pathFor('');
        clr.setAttribute('data-mld-clearall', '');
        clr.setAttribute('aria-label', 'Quitar todos los filtros');
        clr.innerHTML = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" aria-hidden="true"><path d="M4.5 4.5l7 7M11.5 4.5l-7 7"/></svg>';
        inner.appendChild(clr);
        inner.classList.add('has-sum');
      } else {
        var cnt = $('[data-mld-count]');
        if (cnt) { var cs = document.createElement('span'); cs.className = 'mld-col-fixed__n'; cs.innerHTML = cnt.innerHTML; inner.appendChild(cs); }
      }
      fixed.appendChild(inner);
      document.body.appendChild(fixed);
      $$('a,button', fixed).forEach(function (n) { n.tabIndex = -1; });
    }
    var hdr = document.getElementById('shopify-section-header');
    function headerBottom() {
      if (!hdr) return 0;
      var r = hdr.getBoundingClientRect();
      return getComputedStyle(hdr).position === 'fixed' ? Math.max(0, Math.round(r.bottom)) : 0;
    }
    var shown = false, ticking = false;
    function syncFixed() {
      ticking = false;
      if (!fixed || !tools) return;
      var hb = headerBottom();
      var show = tools.getBoundingClientRect().bottom < hb + 2 && !H.classList.contains('mld-col-lock');
      fixed.style.top = hb + 'px';
      if (show !== shown) {
        shown = show;
        fixed.classList.toggle('is-on', show);
        fixed.setAttribute('aria-hidden', show ? 'false' : 'true');
        $$('a,button', fixed).forEach(function (n) { n.tabIndex = show ? 0 : -1; });
      }
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(syncFixed); } }, { passive: true });
    window.addEventListener('resize', function () { requestAnimationFrame(syncFixed); });
    syncFixed();

    /* ── Hoja ─────────────────────────────────────────────── */
    var lastFocus = null, countTimer = null, countSeq = 0;
    var apply = sheet && $('[data-mld-apply]', sheet);
    function setApplyLabel(n) {
      if (!apply) return;
      apply.textContent = n == null ? 'Ver productos' : n === 0 ? 'Sin resultados con estos filtros' : 'Ver ' + fmt(n) + ' producto' + (n === 1 ? '' : 's');
      /* CR-62: con 0 resultados el botón no aplica (queda deshabilitado, con el motivo como texto) */
      apply.disabled = n === 0;
      var live = sheet && $('[data-mld-live]', sheet);
      if (live && n != null) live.textContent = n === 0 ? 'Sin resultados con estos filtros' : fmt(n) + ' producto' + (n === 1 ? '' : 's') + ' con estos filtros';
    }
    function refreshCount() {
      clearTimeout(countTimer);
      countTimer = setTimeout(function () {
        var st = sheetState(), seq = ++countSeq;
        var p = targetParams(st);
        fetchJSON(dataUrl(targetPath(st), p, 1)).then(function (d) { if (seq === countSeq) setApplyLabel(d.n); }).catch(function () { setApplyLabel(null); });
      }, 220);
    }
    function syncRangePills() {
      if (!sheet) return;
      var g = $('[data-mld-gte]', sheet), l = $('[data-mld-lte]', sheet);
      $$('input[name="mld_prange"]', sheet).forEach(function (r) {
        var v = r.value.split('|');
        r.checked = !!g && !!l && g.value === v[0] && l.value === v[1];
      });
    }
    function setExpanded(v) { $$('[data-mld-open]').forEach(function (b) { b.setAttribute('aria-expanded', v ? 'true' : 'false'); }); }
    function openSheet() {
      if (!sheet) return;
      lastFocus = document.activeElement;
      setExpanded(true);
      var o = $('[data-mld-oos]', sheet); if (o) o.checked = !H.classList.contains('mld-hide-oos') && urlAvail !== '1';
      if (cur.get('mld_sort') === 'discount') { var dr = $('input[name="mld_sort"][value="discount"]', sheet); if (dr) dr.checked = true; }
      syncRangePills();
      scrim.hidden = false; sheet.hidden = false;
      H.classList.add('mld-col-lock');
      requestAnimationFrame(function () { requestAnimationFrame(function () { scrim.classList.add('is-open'); sheet.classList.add('is-open'); }); });
      var x = $('[data-mld-close]', sheet); if (x) x.focus();
      refreshCount();
      syncFixed();
    }
    function closeSheet() {
      if (!sheet || sheet.hidden) return;
      sheet.classList.remove('is-open'); scrim.classList.remove('is-open');
      H.classList.remove('mld-col-lock');
      setExpanded(false);
      setTimeout(function () { sheet.hidden = true; scrim.hidden = true; }, 220);
      /* Primero se restituye la barra fija (visible y enfocable) y recién después se
         devuelve el foco: si no, el botón de la barra fija seguía oculto y el foco caía en body. */
      syncFixed();
      if (lastFocus && lastFocus.focus && document.contains(lastFocus)) {
        lastFocus.focus({ preventScroll: true });
        if (document.activeElement !== lastFocus) { var mb = $('[data-mld-open]', bar); if (mb) mb.focus({ preventScroll: true }); }
      }
    }
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-mld-open]')) { e.preventDefault(); openSheet(); return; }
      if (t.closest('[data-mld-close]') || t.closest('[data-mld-scrim]')) { closeSheet(); return; }
      if (t.closest('[data-mld-top]')) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        if (mode === 'search') { var si = $('.mld-col-sq input[name="q"]'); if (si) setTimeout(function () { si.focus({ preventScroll: true }); }, 400); }
        return;
      }
      if (t.closest('[data-mld-clear]')) {
        $$('input[type="checkbox"]', sheet).forEach(function (c) { c.checked = false; });
        $$('input[name="mld_tag"],input[name="mld_prange"]', sheet).forEach(function (c) { c.checked = false; });
        $$('input[type="number"]', sheet).forEach(function (c) { c.value = ''; });
        var ds = $('input[name="mld_sort"][value="' + defSort + '"]', sheet) || $('input[name="mld_sort"]', sheet);
        if (ds) ds.checked = true;
        syncRangePills(); refreshCount(); return;
      }
      if (t.closest('[data-mld-apply]') && !t.closest('[data-mld-apply]').disabled) {
        var st = sheetState();
        setCookie('showOutOfStock', st.oos ? 'true' : 'false', 7);
        location.href = targetUrl(st);
      }
    });
    /* Temática y rangos de precio: tocar el activo lo desmarca (radio "deseleccionable"). */
    if (sheet) {
      sheet.addEventListener('pointerdown', function (e) {
        var lab = e.target.closest('[data-mld-tag],[data-mld-range]'); if (lab) { var i = $('input', lab); i.__was = i.checked; }
      });
      sheet.addEventListener('click', function (e) {
        var lab = e.target.closest('[data-mld-tag],[data-mld-range]'); if (!lab) return;
        var inp = $('input', lab);
        if (e.target !== inp || !inp.__was) return;
        inp.checked = false; inp.__was = false;
        if (lab.hasAttribute('data-mld-range')) { var g0 = $('[data-mld-gte]', sheet), l0 = $('[data-mld-lte]', sheet); if (g0) g0.value = ''; if (l0) l0.value = ''; }
        refreshCount();
      });
      sheet.addEventListener('change', function (e) {
        if (e.target.name === 'mld_prange' && e.target.checked) {
          var v = e.target.value.split('|'), g1 = $('[data-mld-gte]', sheet), l1 = $('[data-mld-lte]', sheet);
          if (g1) g1.value = v[0]; if (l1) l1.value = v[1];
        }
        if (e.target.matches('[data-mld-gte],[data-mld-lte]')) syncRangePills();
        refreshCount();
      });
      sheet.addEventListener('input', function (e) { if (e.target.matches('input[type="number"]')) { syncRangePills(); refreshCount(); } });
      sheet.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { closeSheet(); return; }
        if (e.key !== 'Tab') return;
        var f = $$('button:not([disabled]), input, a[href]', sheet).filter(function (n) { return n.offsetParent !== null; });
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      });
    }

    /* ── Grilla: agotados ocultos, orden por descuento, relleno ── */
    var grid = $('.mld-col .products-grid');
    function sortByDiscount() {
      if (!grid || cur.get('mld_sort') !== 'discount') return;
      var cards = $$('.product-preview', grid);
      cards.forEach(function (c, i) { if (!c.hasAttribute('data-base-order')) c.setAttribute('data-base-order', i); });
      cards.sort(function (a, b) {
        var d = (+b.getAttribute('data-discount') || 0) - (+a.getAttribute('data-discount') || 0);
        return d || (+a.getAttribute('data-base-order') - +b.getAttribute('data-base-order'));
      }).forEach(function (c) { grid.appendChild(c); });
    }
    function fill() {
      if (!grid) return;
      var vis = $$('.product-preview', grid).filter(function (c) { return c.offsetParent !== null; }).length;
      var more = !!document.getElementById('next-page-link');
      var empty = $('[data-mld-empty]');
      if (vis < 10 && more) { window.dispatchEvent(new Event('scroll')); }
      if (!vis && !more && H.classList.contains('mld-hide-oos') && $$('.product-preview', grid).length && !empty) {
        var p = document.createElement('p'); p.className = 'mld-col-empty'; p.setAttribute('data-mld-empty', '');
        p.innerHTML = 'No hay productos con stock acá ahora. <button type="button" class="mld-col-link" data-mld-showoos>Mostrar sin stock</button>';
        grid.parentNode.insertBefore(p, grid);
      }
    }
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-mld-showoos]')) return;
      setCookie('showOutOfStock', 'true', 7);
      var p = new URLSearchParams(location.search); p.delete('filter.v.availability');
      location.search = p.toString();
    });
    sortByDiscount();
    document.addEventListener('collection:products-appended', function () { sortByDiscount(); setTimeout(fill, 60); });
    setTimeout(fill, 300);

    /* ── Búsqueda: borrar término ───────────────────────── */
    var sx = $('[data-mld-sq-clear]');
    if (sx) sx.addEventListener('click', function () { var i = $('.mld-col-sq input[name="q"]'); if (i) { i.value = ''; i.focus(); } });

    /* ── Catálogo: la marquesina va después de la primera fila ── */
    if (mode === 'catalog') {
      var root = bar.closest('.mos');
      var trust = root && $('.mos-trust', root);
      var rowsBox = root && $('[data-mos-rows]', root);
      var mgrid = root && $('[data-mos-grid]', root);
      if (trust && rowsBox && mgrid) {
        var placeTrust = function () {
          var first = !rowsBox.hidden && $('.mos-row:not([hidden])', rowsBox);
          if (first) { if (first.nextElementSibling !== trust) first.after(trust); }
          else if (mgrid.nextElementSibling !== trust) mgrid.after(trust);
        };
        placeTrust();
        new MutationObserver(placeTrust).observe(rowsBox, { attributes: true, attributeFilter: ['hidden'], childList: true });
      }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  /* ── Búsqueda: ranking por palabra entera y categoría material + forma ──
     Los usa también el predictivo (snippets/search-modal.liquid, zona inicio+global):
       window.mldRankByWord(query, items) → copia ordenada (estable). items: strings,
         objetos con .title/.name o elementos (usa data-title o el texto). "flor" antes que "florero".
       window.mldCategoryFor(query) → { url, label } | null, con window.mldCatMap
         (snippet mld-coleccion-catmap). "vela flor" → /collections/velas/flores. */
  function norm(x) { return String(x || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9ñ]+/g, ' ').trim(); }
  function stems(w) {
    var out = [w];
    if (w.length > 3 && /es$/.test(w)) out.push(w.slice(0, -2));
    if (w.length > 2 && /s$/.test(w)) out.push(w.slice(0, -1));
    return out;
  }
  function wordSet(t) { var set = {}; norm(t).split(' ').forEach(function (w) { if (w) stems(w).forEach(function (s) { set[s] = 1; }); }); return set; }
  function itemText(it) {
    if (it == null) return '';
    if (typeof it === 'string') return it;
    if (it.nodeType === 1) return it.getAttribute('data-title') || it.textContent || '';
    return it.title || it.name || it.label || '';
  }
  window.mldRankByWord = function (query, items) {
    var qw = norm(query).split(' ').filter(function (w) { return w.length > 1; });
    var list = Array.prototype.slice.call(items || []);
    if (!qw.length) return list;
    return list.map(function (it, i) {
      var ws = wordSet(itemText(it)), score = 0;
      qw.forEach(function (w) { if (stems(w).some(function (s) { return ws[s]; })) score++; });
      return { it: it, i: i, s: score };
    }).sort(function (a, b) { return (b.s - a.s) || (a.i - b.i); }).map(function (x) { return x.it; });
  };
  var catTagsCache = {};
  window.mldCategoryFor = function (query) {
    var map = window.mldCatMap; if (!map) return Promise.resolve(null);
    var ws = wordSet(query), mat = null, shape = null, matWord = '';
    var words = norm(query).split(' ');
    (map.mats || []).some(function (m) {
      var st = stems(m.h);
      return words.some(function (w) { if (stems(w).some(function (x) { return st.indexOf(x) > -1; })) { mat = m; matWord = w; return true; } });
    });
    (map.shapes || []).some(function (m) { if (stems(m.h).some(function (x) { return ws[x]; })) { shape = m; return true; } });
    if (!mat) return Promise.resolve(shape ? { url: shape.url, label: shape.t } : null);
    var rest = words.filter(function (w) { return w && w !== matWord; }).join(' ');
    var base = { url: mat.url, label: mat.t };
    if (!rest) return Promise.resolve(base);
    var tp = catTagsCache[mat.url] || (catTagsCache[mat.url] = fetch(mat.url + '?view=' + DATA_VIEW, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (t) { return JSON.parse(t.slice(t.indexOf('{'))).tags || []; }));
    return tp.then(function (tags) {
      var t = matchTag(tags, rest);
      return t ? { url: mat.url + '/' + t[0], label: mat.t + ': ' + tagLabel(t) } : base;
    }).catch(function () { return base; });
  };


  /* Tarjeta de producto con variantes: el "+" (data-qv-open) abre la vista rápida de la página.
     Si la página no tiene vista rápida, lleva a la ficha para elegir la opción (nunca agrega a ciegas). */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-qv-open]');
    if (!b || document.querySelector('[data-mos-qv]')) return;
    e.preventDefault();
    window.location.href = '/products/' + b.getAttribute('data-qv-open');
  });

})();
